import { Client, cacheExchange, fetchExchange } from 'urql';

export * from './generated';

const SECTION_API = {
  velumia: '/velumia/version/latest',
  votings: '/votings/version/latest',
}

export const graphqlClient = new Client({
  url: `https://api.studio.thegraph.com/query/108249${SECTION_API.velumia}`,
  exchanges: [cacheExchange, fetchExchange],
});
